import Image from "next/image";

import imageLoader from "../../../utils/loader";
import classes from "./loader.module.scss";

interface Props {
  center?: boolean;
}
const EatfidLoader = ({ center = false }: Props) => {
  return (
    <div className={classes.conent}>
      <div className={`${classes.loader} ${center && classes.center}`}>
        <Image
          loader={imageLoader}
          src="loader.png"
          alt="Loader"
          height={140}
          width={140}
        />
      </div>
    </div>
  );
};

export default EatfidLoader;
